import {
  ErrorPayloadResponse, ErrorResponse, ErrorsMap, ValidationError,
} from 'src/types/Errors';
import { logger } from 'src/utils';
import { Logs } from 'src/constants/metrics';

export const parseErrorResponse = ({ message }: { message: string }) => {
  try {
    const errors: ErrorPayloadResponse = JSON.parse(message);
    return errors;
  } catch (error) {
    logger.error(Logs.badRequestException, error as Error, { message });
    return null;
  }
};

export default function getFieldErrorList(errorsResponse: ErrorResponse, errorsMap: ErrorsMap) {
  const fieldErrors: ValidationError[] = Object.entries(errorsResponse).map((errorEntry) => {
    const [errorField, errorsArray] = errorEntry;
    const typedErrorField = errorField as keyof typeof errorsMap;
    const errorMessageMap = errorsMap[typedErrorField];
    const errors = errorsArray && errorsArray
      .filter((error: string) => Object.keys(errorMessageMap).includes(error))
      .map((error: string) => errorMessageMap[error]).join(',');

    return {
      errorField,
      errors,
    } as ValidationError;
  });
  return fieldErrors;
}
